import {
  GET_NOTESASSOCIATES,
  CREATE_NOTESASSOCIATES,
  DELETE_NOTESASSOCIATES,
  UPDATE_NOTESASSOCIATES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  notesAssociates: [],
  error: {},
  success: "",
};

const NotesAssociates = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_NOTESASSOCIATES:
          return {
            ...state,
            notesAssociates: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_NOTESASSOCIATES:
          return {
            ...state,
            success: "Sucessfully created notesAssociates",
            error: {},
          };
        case UPDATE_NOTESASSOCIATES:
          return {
            ...state,
            success: "Sucessfully updated notesAssociates",
            error: {},
          };
        case DELETE_NOTESASSOCIATES:
          return {
            ...state,
            success: "Sucessfully delete notesAssociates",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_NOTESASSOCIATES:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        case CREATE_NOTESASSOCIATES:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        case UPDATE_NOTESASSOCIATES:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        case DELETE_NOTESASSOCIATES:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        default:
          return { ...state };
      }
    case GET_NOTESASSOCIATES: {
      return {
        ...state,
      };
    }
    case CREATE_NOTESASSOCIATES: {
      return {
        ...state,
      };
    }
    case UPDATE_NOTESASSOCIATES: {
      return {
        ...state,
      };
    }
    case DELETE_NOTESASSOCIATES: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default NotesAssociates;
